export default "__VITE_ASSET__DZPJR6Sl__"